import React from 'react';
import { Grid, Radio, RadioGroup, Stack, Text } from '@chakra-ui/react';
import { Options } from '~/types/technicalSupport';

interface AnswerOptionsProps {
  pergunta: string;
  opcoes?: Options[];
  changeSelecao?: (nome: string) => void;
}
export const AnswerOptions: React.VFC<AnswerOptionsProps> = ({
  pergunta,
  opcoes = [],
  changeSelecao,
}) => {
  return (
    <Stack gridGap={2} w="80%">
      <Text
        fontSize="16px"
        dangerouslySetInnerHTML={
          /.*<.*/.test(pergunta) ? { __html: pergunta } : undefined
        }
      >
        {/.*<.*/.test(pergunta) ? null : pergunta}
      </Text>
      {opcoes && (
        <RadioGroup onChange={changeSelecao}>
          <Grid templateColumns="repeat(2, 1fr)" gap={2}>
            {opcoes?.map(opcao => (
              <Radio
                key={opcao.id}
                colorScheme="b"
                value={opcao.name}
                borderColor="blackAlpha.500"
              >
                {opcao.name}
              </Radio>
            ))}
          </Grid>
        </RadioGroup>
      )}
    </Stack>
  );
};
